import { useState } from 'react';
import { ActionButton } from '../parts/ActionButton.js';
import { ComposerIcon } from './ComposerIcon.js';
import { EmojiPicker } from './EmojiPicker.js';

export function EmojiButton({ disabled, onOpen, onPick, onClose }: {
  disabled?: boolean; onOpen: () => void; onPick: (emoji: string) => void; onClose: () => void;
}) {
  const [open, setOpen] = useState(false);
  return <span className="ch-emoji-anchor">
    <ActionButton type="button" className="ch-compose-icon" aria-label="Emoji" title="Emoji" disabled={disabled}
      aria-expanded={open} aria-haspopup="dialog" onMouseDown={e => e.preventDefault()}
      onClick={() => { if (open) { setOpen(false); onClose(); } else { onOpen(); setOpen(true); } }}><ComposerIcon name="Emoji" /></ActionButton>
    {open && !disabled ? <EmojiPicker onPick={emoji => { setOpen(false); onPick(emoji); }} onClose={() => { setOpen(false); onClose(); }} /> : null}
  </span>;
}
